import React from 'react';
import '../../../v2-theme.css';

/**
 * V2Select Component
 *
 * Select dropdown with v2 design system styling
 *
 * @param {string} label - Select label text
 * @param {string} name - Select name attribute
 * @param {string} value - Selected value
 * @param {function} onChange - Change handler
 * @param {Array} options - Array of {value, label} objects
 * @param {boolean} required - Whether select is required
 * @param {string} error - Error message to display
 * @param {boolean} disabled - Whether select is disabled
 * @param {string} placeholder - Placeholder option text
 */
const V2Select = ({
  label,
  name,
  value,
  onChange,
  options = [],
  required = false,
  error = '',
  disabled = false,
  placeholder = 'Select an option',
  className = '',
  ...props
}) => {
  const selectClasses = [
    'v2-select',
    error ? 'v2-select-error' : '',
    disabled ? 'v2-select-disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className="v2-form-group">
      {label && (
        <label className="v2-label" htmlFor={name}>
          {label}
          {required && <span className="v2-required">*</span>}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className={selectClasses}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <div className="v2-error-message">{error}</div>}
    </div>
  );
};

export default V2Select;
